import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import SettingsPage from '../partials/SettingsPage';
import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import MarkPaidModal from './MarkPaidModal';
import ClosePOModal from './ClosePOModal';
import IssueModal from './IssueModal';
import DeletePOModal from './DeletePOModal';
import MarkFulfilledModal from './MarkFulfilledModal';

import DownloadPdfModal from './DownloadPdfModal';

import { Button, Text, Small, Panel, H3, H4, Badge, Box, Radio, Switch, Tooltip } from '@bigcommerce/big-design';
import { AddIcon, DeleteIcon, FileDownloadIcon, EditIcon, ReceiptIcon, AssignmentIcon, ChevronRightIcon, ChevronLeftIcon, VisibilityIcon, CheckIcon, ContentCopyIcon } from '@bigcommerce/big-design-icons';

import { purchaseOrdersIndex, resetNewPurchaseOrder, reset } from '../../redux/actions/purchaseOrders';
import { suppliersIndex } from '../../redux/actions/suppliers';

const PurchaseOrders = ({ payload, loadPurchaseOrders, loadSuppliers, purchaseOrders, suppliers, clearNewPurchaseOrder, resetPurchaseOrders, settings, bigcommerceSettings }) => {
  const [modalOrder, setModalOrder] = useState(null);
  const [showMarkPaidModal, setShowMarkPaidModal] = useState(false);
  const [showUpdateShipmentModal, setShowUpdateShipmentModal] = useState(false);
  const [showIssueModal, setShowIssueModal] = useState(false);
  const [showClosePOModal, setShowClosePOModal] = useState(false);
  const [showDeletePOModal, setShowDeletePOModal] = useState(false);
  const [showShipmentsModal, setShowShipmentsModal] = useState(false);
  const [showMarkFulfilledModal, setShowMarkFulfilledModal] = useState(false);
  const [showDownloadPdfModal, setShowDownloadPdfModal] = useState(false);

  const [reverseOrder, setReverseOrder] = useState(true);
  const [sortKey, setSortKey] = useState(null);

  const [page, setPage] = useState(0);

  useEffect(() => {
    loadNextPurchaseOrders();
    loadSuppliers(payload);
    clearNewPurchaseOrder();
  }, []);

  const loadPreviousPurchaseOrders = () => {
    let previousContinuationToken = purchaseOrders.purchaseOrdersSearchStack[page - 2];
    loadPurchaseOrders(payload, previousContinuationToken, (page - 1), sortKey, reverseOrder);
    setPage(page - 1);
  }

  const loadNextPurchaseOrders = () => {
    loadPurchaseOrders(payload, purchaseOrders.purchaseOrdersSearchStack[page], (page + 1), sortKey, reverseOrder);
    setPage(page + 1);
  }

  const openMarkIssued = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowIssueModal(true);
  }

  const openMarkFulfilled = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowMarkFulfilledModal(true);
  }

  const openMarkPaid = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowMarkPaidModal(true);
  }

  const openMarkClosed = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowClosePOModal(true);
  }

  const openMarkDeleted = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowDeletePOModal(true);
  }

  const openShipments = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowShipmentsModal(true);
  }

  const openDownloadPdf = (purchaseOrder) => {
    setModalOrder(purchaseOrder);
    setShowDownloadPdfModal(true);
  }

  const format = (value) => {
    let formattedValue = "";

    if(bigcommerceSettings.currency_symbol_location === 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }
    
    formattedValue += parseFloat(value).toFixed(bigcommerceSettings.decimal_places)

    if(bigcommerceSettings.currency_symbol_location !== 'left') {
      formattedValue += bigcommerceSettings.currency_symbol
    }

    formattedValue = formattedValue.replace('.', bigcommerceSettings.decimal_separator)

    return formattedValue;
  }

  const supplierData = (supplierId) => {
    let supplier = suppliers.suppliers.find(supplier => supplier.id === supplierId);

    if(supplier) {
      return (
        <>
          <strong>Supplier</strong>: { supplier.supplier_name }
          <br/>
          { supplier.account_number &&
            <>
              <strong>Account Number</strong>: { supplier.account_number }
              <br/>
            </>
          }
          { supplier.contact_email &&
            <>
              <strong>Contact Email</strong>: { supplier.contact_email }
              <br/>
            </>
          }
          { supplier.contact_phone &&
            <>
              <strong>Contact Phone</strong>: { supplier.contact_phone }
              <br/>
            </>
          }
        </>
      )
    }

    return(
      <>
        <Text><strong>Supplier</strong>: Supplier no longer exists</Text>
      </>
    )
  }

  const setOrder = (event) => {
    setSortKey(event.target.value);
    resetPurchaseOrders();
    loadPurchaseOrders(payload, null, 1, event.target.value, reverseOrder);
    setPage(1);
    clearNewPurchaseOrder();
  }

  const switchOrder = () => {
    setReverseOrder(!reverseOrder);
    resetPurchaseOrders();
    loadPurchaseOrders(payload, null, 1, sortKey, !reverseOrder);
    setPage(1);
    clearNewPurchaseOrder();
  }

  const description = () => {
    return(
      <> 
        <Text>From this page, you can manage purchase orders.</Text>
        <Text>Click the "New Purchase Order" button to start a new purchase order, or take actions on the outstanding purchase orders from the panel below.</Text>
        <Text>Paginate through sets of 10 purchase orders by clicking the "Previous Purchase Orders" or "Next Purchase Orders" buttons.</Text>
        <Text>For new, draft purchase orders, you can download the PDF to send to the supplier, edit the purchase order, or mark the draft as issued, or paid by clicking the buttons to the right of the purchase order's row.</Text>
        <Text>For issued purchase orders, or partially fulfilled purchase orders, you can download the order's PDF, update incoming shipment information to help track shipments from suppliers, mark the purchase order paid, update parts of the purchase order or receive shipments for the order by clicking buttons to the right of the purchase order's row.</Text>
        <Text>For fulfilled purchase orders, you can download the purchase order's PDF, mark the order as paid or close the purchase order by clicking buttons to the right of the purchase order's row.</Text>
        <Text>You can cancel or reject the remaining steps for any purchase order at any time by clicking the red garbage can icon on any purchase order's row.</Text>
        <Small>Have questions or need some help? Contact us at <a href="mailto:support@athousandapps.com">support@athousandapps.com</a></Small>
      </>
    )
  }

  return(
    <>
      <PageHeader stripeBackground='#070808' helpLink="bigcommerce/manage-purchase-orders/" />
      <SettingsPage title="Purchase Orders" description={description()}>
        <Panel>
          <Link to="/purchase_order/new">
            <Button iconLeft={<AddIcon />}>
              New Purchase Order
            </Button>
          </Link>
          <hr/>
          <Link to="/purchase_orders/archived">
            <Button variant="secondary" iconLeft={<VisibilityIcon />}>
              View Archived Purchase Orders
            </Button>
          </Link>
          <span className="left-15">
            <Link to="/purchase_orders/rejected">
              <Button variant="secondary" iconLeft={<VisibilityIcon />}>
                View Rejected Purchase Orders
              </Button>
            </Link>
          </span>
        </Panel>

        <Panel>
          <H3>Sort Options</H3>

          <div className="flex-container">
            <div className="flex-1">
              <H4>Sort Key</H4>
              <Tooltip placement="top-start" trigger={
                <span>
                  <Radio
                    checked={!sortKey}
                    label="Creation Date"
                    onChange={setOrder}
                    value={null}
                  />
                </span>
              }>
                Purchase orders created after April 16, 2025 can be sorted by creation date
              </Tooltip>
              <Radio
                checked={sortKey === 'invoice_number'}
                label={`${settings.settings['invoice_number_override'] || 'Invoice Number'}`}
                onChange={setOrder}
                value="invoice_number"
              />
              <Radio
                checked={sortKey === 'supplier_number'}
                label={`${settings.settings['purchase_order_number_override'] || 'Purchase Order Number'}`}
                onChange={setOrder}
                value="supplier_number"
              />
            </div>

            <div className="flex-1">
              <H4>Reverse Order</H4>
              <Switch checked={reverseOrder} onChange={switchOrder} />
            </div>
          </div>
        </Panel>

        <Panel>
          <H3>Outstanding Purchase Orders</H3>
          <div className="flex-container">
            <div className="flex-1">
              <Button
                onClick={() => loadPreviousPurchaseOrders()}
                disabled={page === 1}
                iconLeft={<ChevronLeftIcon />}
                variant="secondary"
              >
                Previous Purchase Orders
              </Button>

              <Button
                onClick={() => loadNextPurchaseOrders()}
                disabled={purchaseOrders.lastPage}
                iconRight={<ChevronRightIcon />}
                variant="secondary"
              >
                Next Purchase Orders
              </Button>
            </div>
          </div>
          <br/>

          { purchaseOrders.isFetching &&
            <LoadingSpinner statusText="Loading Purchase Orders" />
          }

          { purchaseOrders.purchaseOrders.length === 0 && !purchaseOrders.isFetching &&
            <Box
              backgroundColor="warning10"
              border="box"
              borderRadius="normal"
              padding="medium"
            >
              <div className="text-center">
                <Text>No outstanding purchase orders. When you have incomplete purchase orders, you'll see them in a list here.</Text>
                <Link to="/purchase_order/new">
                  <Button iconLeft={<AddIcon />}>
                    Create a Purchase Order
                  </Button>
                </Link>
              </div>
            </Box>
          }

          { purchaseOrders.purchaseOrders.map(purchaseOrder =>
            <>
              <H4>
                {purchaseOrder.invoice_number || purchaseOrder.id}
                <span className="left-15">
                  <Link to={`/purchase_order/copy/${purchaseOrder.id}`}>
                    <Button
                      iconOnly={<ContentCopyIcon />}
                      variant="secondary"
                    />
                  </Link>

                  <span className="left-15">
                    <Button
                      actionType="destructive"
                      iconOnly={<DeleteIcon title="delete" />}
                      variant="secondary"
                      onClick={() => openMarkDeleted(purchaseOrder)}
                      disabled={purchaseOrders.updatingRejectedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                      isLoading={purchaseOrders.updatingRejectedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                    />
                  </span>
                </span>
              </H4>
              
              <div className="flex-container space-between">
                <div className="flex1 left-15">
                  { purchaseOrder.supplier_order_number &&
                    <>
                      <strong>Purchase Order Number</strong>: { purchaseOrder.supplier_order_number }
                      <br/>
                    </>
                  }
                  { purchaseOrder.supplier_id && suppliers.status === 'success' &&
                    <>
                      {supplierData(purchaseOrder.supplier_id)}
                    </>
                  }
                  { purchaseOrder.supplier_id && suppliers.isFetching &&
                    <LoadingSpinner size="xxSmall" statusText="Loading Suppliers" />
                  }

                </div>

                <div className="flex1 left-15">
                  <strong>PO Status</strong>: <Badge label={ purchaseOrder.status } variant={ purchaseOrder.status === 'fulfilled' ? "success" : (purchaseOrder.status === 'draft' ? "warning" : "secondary") } /><br/>
                  <strong>Type</strong>: <Badge label={ purchaseOrder.ship_to_type } variant={ "secondary" } /><br/>
                  <strong>Shipment Expected</strong>: <Badge label={ (new Date(purchaseOrder.shipment_expected_at)).toISOString().split('T')[0] } variant={ ( (new Date(purchaseOrder.shipment_expected_at)) > (new Date()) ) ? "secondary" : "warning" } />
                  <br/>
                  { (purchaseOrder.status === 'fulfilled' || purchaseOrder.status === 'partially_fulfilled') &&
                    <Link to={`/warehouse_receiving_orders/purchase_order/${purchaseOrder.id}`}>
                      <Button
                        variant="subtle"
                        iconLeft={<VisibilityIcon />}
                      >
                        View WROs
                      </Button>
                    </Link>
                  }
                  { (purchaseOrder.status === 'partially_fulfilled') &&
                    <>
                      <Button
                        variant="subtle"
                        iconLeft={<CheckIcon />}
                        disabled={purchaseOrders.updatingIssuedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                        isLoading={purchaseOrders.updatingIssuedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                        onClick={() => openMarkFulfilled(purchaseOrder)}
                      >
                        Mark Fulfilled
                      </Button>
                    </>
                  }
                </div>

                <div className="flex1 left-15">
                  <strong>Payment status</strong>: <Badge label={ purchaseOrder.payment_status } variant={ purchaseOrder.payment_status === 'open' ? "warning" : "success" } />
                  <br/>
                  <strong>Payment due</strong>: <Badge label={ (new Date(purchaseOrder.payment_due_at)).toISOString().split('T')[0] } variant={ ( (new Date(purchaseOrder.payment_due_at)) > (new Date()) ) ? "secondary" : "warning" } /><br/>
                  <strong>PO Total</strong>: <Badge label={ format(purchaseOrder.total) } variant='secondary' />
                  { purchaseOrder.payment_status === 'open' &&
                    <>
                      <br/>
                      <Button
                        variant="subtle"
                        onClick={() => openMarkPaid(purchaseOrder) }
                        disabled={purchaseOrders.updatingPaidList.findIndex(poId => poId === purchaseOrder.id) > -1}
                        isLoading={purchaseOrders.updatingPaidList.findIndex(poId => poId === purchaseOrder.id) > -1}
                        iconLeft={<ReceiptIcon />}
                      >
                        Mark PO Paid
                      </Button>
                    </>
                  }
                </div>
                
                <div className="flex1 left-15 flex-container flex-column">
                  <Button
                    variant="subtle"
                    onClick={() => openDownloadPdf(purchaseOrder)}
                    iconLeft={<FileDownloadIcon />}
                  >
                    Download PDF
                  </Button>
                  <br/>
                  
                  { purchaseOrder.status === 'draft' &&
                    <>
                      <Link to={`/purchase_order/edit/${purchaseOrder.id}`}>
                        <div className="full-width">
                          <Button
                            variant="utility"
                            iconLeft={<EditIcon />}
                          >
                            Edit PO
                          </Button>
                        </div>
                      </Link>
                      
                      <br/>
                      <Button
                        variant="secondary"
                        onClick={() => openMarkIssued(purchaseOrder)}
                        disabled={purchaseOrders.updatingIssuedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                        isLoading={purchaseOrders.updatingIssuedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                        iconLeft={<AssignmentIcon />}
                      >
                        Mark PO Issued
                      </Button>
                    </>
                  }

                  { (purchaseOrder.status === 'issued' || purchaseOrder.status === 'partially_fulfilled') &&
                    <>
                      <Link to={`/purchase_order/shipments/${purchaseOrder.id}`}>
                        <div className="full-width">
                          <Button
                            variant="utility"
                            iconLeft={<AssignmentIcon />}
                          >
                            Update Shipment Info
                          </Button>
                        </div>
                      </Link>
                      <br/>
                      <Link to={`/purchase_order/receive/${purchaseOrder.id}`}>
                        <div className="full-width">
                          <Button
                            variant="secondary"
                            iconLeft={<ReceiptIcon />}
                          >
                            Update or Receive Shipment
                          </Button>
                        </div>
                      </Link>
                    </>
                  }

                  { purchaseOrder.status === 'fulfilled' &&
                    <Button
                      variant="secondary"
                      disabled={ (purchaseOrder.payment_status === 'open') || (purchaseOrders.updatingClosedList.findIndex(poId => poId === purchaseOrder.id) > -1) }
                      onClick={() => openMarkClosed(purchaseOrder) }
                      isLoading={purchaseOrders.updatingClosedList.findIndex(poId => poId === purchaseOrder.id) > -1}
                    >
                      Close PO
                    </Button>
                  }
                </div>
              </div>
              <hr/>
            </>
          )}

        </Panel>
        <MarkPaidModal
          payload={payload}
          showMarkPaidModal={showMarkPaidModal}
          setShowMarkPaidModal={setShowMarkPaidModal}
          purchaseOrder={modalOrder}
        />
        <ClosePOModal
          payload={payload}
          showClosePOModal={showClosePOModal}
          setShowClosePOModal={setShowClosePOModal}
          purchaseOrder={modalOrder}
        />
        <IssueModal
          payload={payload}
          showIssueModal={showIssueModal}
          setShowIssueModal={setShowIssueModal}
          purchaseOrder={modalOrder}
        />
        <MarkFulfilledModal
          payload={payload}
          showMarkFulfilledModal={showMarkFulfilledModal}
          setShowMarkFulfilledModal={setShowMarkFulfilledModal}
          purchaseOrder={modalOrder}
        />
        <DeletePOModal
          payload={payload}
          showDeletePOModal={showDeletePOModal}
          setShowDeletePOModal={setShowDeletePOModal}
          purchaseOrder={modalOrder}
        />

        <DownloadPdfModal
          payload={payload}
          purchaseOrder={modalOrder}
          showDownloadPdfModal={showDownloadPdfModal}
          setShowDownloadPdfModal={setShowDownloadPdfModal}
        />

      </SettingsPage>
    </>
  )

}

const mapStateToProps = state => ({
  bigcommerceSettings: state.stores.settings,
  purchaseOrders: state.purchaseOrders,
  suppliers: state.suppliers,
  settings: state.settings,
});

const mapDispatchToProps = (dispatch) => ({
  loadPurchaseOrders: (payload, continuationToken, page, sortKey, reverseOrder) => dispatch(purchaseOrdersIndex(payload, 'outstanding', continuationToken, page, sortKey, reverseOrder)),
  loadSuppliers: (payload) => dispatch(suppliersIndex(payload)),
  clearNewPurchaseOrder: () => dispatch(resetNewPurchaseOrder()),
  resetPurchaseOrders: () => dispatch(reset()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PurchaseOrders);